import React from 'react';
import { useHistory } from 'react-router-dom';
import '../styles/components/footerNew.scss';

export default function FooterNew() {
	const navigate = useHistory();
	return (
		<footer>
			<div className='container'>
				<div className='webbler_wrap'>
					<div className='webbler'>
						<h2 className='web'>Webbler</h2>
						<p style={{ whiteSpace: 'nowrap' }}>
							Creating personal websites made easy
						</p>
					</div>

					<p className='paragraph'>
						Webbler is web platform that can be used to create personal websites. You
						don't have to have any coding skills to use this. Select your template now
						and start adding your bio, social media links, achievements, photos and
						videos. Share your web page wherever you like!
					</p>
				</div>
				<div className='rules'>
					<div className='rules_1'>
						<a href='' className='privacy-policy'>
							<span onClick={() => navigate.push('/privacy-policy')}>
								Privacy policy
							</span>
						</a>
						<a href='' className='terms'>
							<span onClick={() => navigate.push('/terms-of-service')}>
								Terms and conditions
							</span>
						</a>
					</div>

					<div className='social'>
						<a href='#'>
							<i className='fa fa-youtube-play fa-2x' aria-hidden='true'></i>
						</a>
						<a href='#'>
							<i className='fa fa-twitter fa-2x' aria-hidden='true'></i>
						</a>
						<a href='#'>
							<i className='fa fa-linkedin fa-2x' aria-hidden='true'></i>
						</a>
						<a href='#'>
							<i className='fa fa-instagram fa-2x' aria-hidden='true'></i>
						</a>
						<a href='#'>
							<i className='fa fa-facebook fa-2x' aria-hidden='true'></i>
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
}
